/** True when the next page's offset would pass `maxOffset` (no cap when undefined). */
export function atOffsetCap(
  offset: number,
  limit: number,
  maxOffset: number | undefined,
): boolean {
  return maxOffset !== undefined && offset + limit > maxOffset;
}

/**
 * Prev/Next pager for offset-paginated admin tables that have no total count.
 * "Next" is disabled once a page comes back shorter than `limit`, or when the
 * next offset would pass `maxOffset` (the highest offset the endpoint accepts).
 */
export function Pager({
  offset,
  limit,
  count,
  maxOffset,
  onChange,
}: {
  offset: number;
  limit: number;
  count: number;
  maxOffset?: number;
  onChange: (offset: number) => void;
}) {
  const capped = atOffsetCap(offset, limit, maxOffset);
  return (
    <div className="mt-3 flex items-center justify-between text-sm text-slate-500">
      <span>
        Page {Math.floor(offset / limit) + 1} · {count} rows
        {/* Say why Next is dead at the cap rather than leave a silent button. */}
        {capped && count === limit && " · narrow the filters to see older rows"}
      </span>
      <div className="flex gap-2">
        <button
          type="button"
          disabled={offset === 0}
          onClick={() => onChange(Math.max(0, offset - limit))}
          className="rounded border border-slate-200 px-3 py-1 hover:bg-slate-50 disabled:opacity-50"
        >
          Prev
        </button>
        <button
          type="button"
          disabled={count < limit || capped}
          onClick={() => onChange(offset + limit)}
          className="rounded border border-slate-200 px-3 py-1 hover:bg-slate-50 disabled:opacity-50"
        >
          Next
        </button>
      </div>
    </div>
  );
}
